var render = function render(){var _vm=this,_c=_vm._self._c;return _c('snack-bar',{ref:"snacker",attrs:{"baseSize":"100px","holdTime":10000,"multiple":true,"position":_vm.position,"colors":_vm.snackColors}})
}
var staticRenderFns = []

export { render, staticRenderFns }